import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { monthNames } from "../../../Utils/externalFunctions";
import { Link } from "react-router-dom";

const AbsenTahunanColumns = [
  {
    name: <DataTableTitle text={"Nama Staf"} />,
    selector: (row) => row.nama,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Grup Staf"} />,
    selector: (row) => row.group_staf,
    sortable: true,
    wrap: true,
  },
  ...monthNames.map((month, index) => {
    return {
      name: <DataTableTitle text={month} />,
      selector: (row) => (
        <Link
          to={`/absen/${row.id}/bulanan?periode=${row.year}-${(index + 1)
            .toString()
            .padStart(2, "0")}`}
        >
          <div className="row">
            <small>H: {row.rekap_absensi[index].jumlah_h}</small>
            <small>A: {row.rekap_absensi[index].jumlah_a}</small>
            <small>PSW: {row.rekap_absensi[index].jumlah_psw}</small>
            <small>TLD: {row.rekap_absensi[index].jumlah_tld}</small>
          </div>
        </Link>
      ),
      wrap: true,
    };
  }),
  {
    name: <DataTableTitle text={"Total"} />,
    selector: (row) => {
      const totalRekap = row.rekap_absensi?.reduce(
        (accumulator, item) => {
          return {
            jumlah_h: accumulator.jumlah_h + (item?.jumlah_h || 0),
            jumlah_a: accumulator.jumlah_a + (item?.jumlah_a || 0),
            jumlah_psw: accumulator.jumlah_psw + (item?.jumlah_psw || 0),
            jumlah_tld: accumulator.jumlah_tld + (item?.jumlah_tld || 0),
          };
        },
        {
          jumlah_h: 0,
          jumlah_a: 0,
          jumlah_psw: 0,
          jumlah_tld: 0,
        }
      );

      return (
        <div className="row">
          <small>H: {totalRekap?.jumlah_h}</small>
          <small>A: {totalRekap?.jumlah_a}</small>
          <small>PSW: {totalRekap?.jumlah_psw}</small>
          <small>TLD: {totalRekap?.jumlah_tld}</small>
        </div>
      );
    },
    wrap: true,
  },
];

export default AbsenTahunanColumns;
